

export default function AboutStand() {
  return (
    <>
    <section className="aboutpage-stand">
        <div className="container">
            <div className="row">  

                <div className="col-lg-3 col-md-3">
                    <h4 className="heading">What we Stand for</h4>
                </div>

                <div className="col-lg-5 col-md-5">
                    <div className="aboutstand-text">
                        <span className="sub-tittle">Our Philosophy</span>
                        <p className="wow animate__animated animate__slideInUp" data-wow-duration="1.1s" data-wow-delay="0.1s">Saysha Interiors is a quintessential example that shows how aesthetically pleasing interiors hold immense practicality. We are your next-door interior design service provider who promises distinctive spaces blended with personalisation. Needless to say, our designers only believe in the employment of premium materials. </p>

                        <p className="wow animate__animated animate__slideInUp" data-wow-duration="1.2s" data-wow-delay="0.1s">Guided by innovation and excellence, we bring every vision to life with bespoke furniture, modular solutions, millwork, and turnkey execution. Each space we create combines modern aesthetics, custom detailing, superior materials, and enduring functionality, resulting in interiors that radiate harmony, sophistication, and a lasting sense of belonging.</p>
                       
                       <img src="/image/stand-sign.webp" loading="lazy" className="img-responsive" alt="sign"/>
                    </div>
                </div>

                <div className="col-lg-4 col-md-4">
                    <div className="aboutstand-image">
                        <img src="/image/aboutstand.webp" loading="lazy" className="img-responsive" alt="about"/>
                        <p>Key Values</p>
                        <ul>
                            <li>Smart - Craftsmanship</li>
                            <li>Strength - Durability</li>
                            <li>Superb - Design Brilliance</li>
                        </ul>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
